import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { setActiveLanguage, getActiveLanguage, getTranslate } from 'react-localize-redux';
import { ChangeLangFrEn, ChangeLangEnFr } from '../images';


let SmallLanguageButton = ({ translate, location, setActiveLanguage, currentLanguage }) => {
  if(currentLanguage === 'fr_FR') {
    let URL = location ? location.pathname.replace('fr_FR', 'en_US') : ""
    return(
      <div className="nav-link">
        <Link to={URL}  onClick={ () => setActiveLanguage('en_US') }>
          <span  ><img  alt="LOGO" style={{height: '1.5em' }} src={ChangeLangFrEn} /></span>

        </Link>
      </div>
    )
  } else if (currentLanguage === 'en_US'){
    let URL = location ? location.pathname.replace('en_US', 'fr_FR') : ""
    return (
      <div className="nav-link">
        <Link to={URL}  onClick={ () => setActiveLanguage('fr_FR') }>
          <span  ><img  alt="LOGO" style={{height: '1.5em'}} src={ChangeLangEnFr} /></span>

        </Link>
      </div>
    )
  }
  return (
    <div className="nav-link navbar-border-bottom">
      <a onClick={ () => setActiveLanguage('en_US') }>
        <span  ><img  alt="LOGO" style={{height: '1.5em'}} src={ChangeLangFrEn} /></span>
      </a>
    </div>
  )

}
const mapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ setActiveLanguage }, dispatch);
}

SmallLanguageButton = connect(
  mapStateToProps,
  mapDispatchToProps
)(SmallLanguageButton);

export default SmallLanguageButton;



// WEBPACK FOOTER //
// ./src/localeAssets/SmallLanguageButton.js